import { useEffect } from 'react';
import useLocalStorage from '@hooks/use-local-storage';
import useMarketingFiltersQuery from '@hooks/marketing-filters/use-marketing-filters-query';
import { AvailableCountryISOCodes } from '@interfaces/models/country';

interface StoredLocalCountries {
  country: AvailableCountryISOCodes;
  localCountries: string[];
}

const useLocalCountries = (userCountry: AvailableCountryISOCodes) => {
  const [localCountriesStorage, setLocalCountriesStorage] = useLocalStorage<StoredLocalCountries | null>(
    // NOTE: whenever marketingFilters change, make sure to update the cache key version to invalidate old cache
    'preferences/v1/localCountries',
    null,
    false,
  );

  const { localToLocalFilter, refetchMarketingFilters } = useMarketingFiltersQuery(false);

  useEffect(() => {
    if (!localCountriesStorage || localCountriesStorage.country !== userCountry) {
      refetchMarketingFilters();
    }
  }, [userCountry]);

  useEffect(() => {
    const localCountriesFromMarketingFilters = localToLocalFilter?.attributes?.countries;
    if (localCountriesFromMarketingFilters && localCountriesFromMarketingFilters.length > 0) {
      setLocalCountriesStorage({ country: userCountry, localCountries: localCountriesFromMarketingFilters });
    }
  }, [localToLocalFilter]);

  return localCountriesStorage?.localCountries;
};

export default useLocalCountries;
